export default {
  title: 'Payer avec {{method}}',
  hint: 'Appuyez sur le bouton ci-dessous et approuvez le paiement dans la fenêtre {{method}}.',
  confirming: 'Confirmation de votre paiement…',
  cancel: 'Annuler le paiement',
  unavailable: "Ce mode de paiement n'est pas disponible pour le moment. Choisissez-en un autre.",
  approval_timeout:
    "Nous n'avons pas eu de réponse de {{method}}. Si sa fenêtre ne s'est pas ouverte, vérifiez que les pop-ups sont autorisés, puis réessayez ou choisissez un autre moyen de paiement.",
};
